module.exports = __webpack_public_path__ + "img/ico-dues.00970e6b.svg";